export const INFORMATION_BOX_TYPE = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type InformationBoxType = ValueOf<typeof INFORMATION_BOX_TYPE>;
